export const appVersion = (_config, _data, globalConfig) => {
  const pluginData = {
    'app:web:version': globalConfig.app.version.web
  };

  if (globalConfig.app.version.ssr) {
    pluginData['app:ssr:version'] = globalConfig.app.version.ssr;
  }

  return pluginData;
};